import { Badge, useTheme } from '@chakra-ui/react';
import React from 'react';
import { styles } from "../../styles";
import iconoCampus from '../../../../innerAsstes/icono campus/campus_virtual.png'
import { useAppContext } from '../../../../App';
import { Link, useNavigate } from 'react-router-dom';

export default function CampusVirtual({
    from = '',
    customStyles = {}
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile);
  return (
    <Badge style={{ ...style.badge, ...customStyles.container }} fontSize={"1rem"}>
      <div style={{ ...style.roundIcon, ...customStyles.round }}>
        <img style={style.icon} src={iconoCampus} alt='campus-icon' />
      </div>
      <a
        href="https://campusgestar.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{}}
      >
        {isMobile && from === "header" ? '' : 'Campus Virtual'}
      </a>
    </Badge>
  );
}
